module.exports={PRODUCT:{INFORMATION:"Details"},NAVIGATION:{ALL:"Alle Artikel"}};